/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ecommerce_Amazon_Tools_Scope_Detail5Inputs */

const en_svc_ecommerce_amazon_tools_scope_detail5 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marketplaces, SKUs and the numbers that matter to you.`)
};

const ar_svc_ecommerce_amazon_tools_scope_detail5 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الأسواق ووحدات SKU والأرقام التي تهمك.`)
};

const bn_svc_ecommerce_amazon_tools_scope_detail5 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`মার্কেটপ্লেস, SKU আর যে সংখ্যা আপনার কাছে গুরুত্বপূর্ণ।`)
};

const de_svc_ecommerce_amazon_tools_scope_detail5 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marktplätze, SKUs und die Zahlen, die Ihnen wichtig sind.`)
};

const es_svc_ecommerce_amazon_tools_scope_detail5 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marketplaces, SKU y los números que le importan.`)
};

const fr_svc_ecommerce_amazon_tools_scope_detail5 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marketplaces, SKU et les chiffres qui comptent pour vous.`)
};

const pt_svc_ecommerce_amazon_tools_scope_detail5 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marketplaces, SKU e os números que lhe importam.`)
};

const zh_svc_ecommerce_amazon_tools_scope_detail5 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`明确平台、SKU，以及对你重要的数字。`)
};

const tr_svc_ecommerce_amazon_tools_scope_detail5 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pazar yerleri, SKU ve sizin için önemli sayılar.`)
};

const ru_svc_ecommerce_amazon_tools_scope_detail5 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Маркетплейсы, SKU и цифры, которые важны вам.`)
};

const pl_svc_ecommerce_amazon_tools_scope_detail5 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marketplace'y, SKU i liczby istotne dla biznesu.`)
};

/**
* | output |
* | --- |
* | "Marketplaces, SKUs and the numbers that matter to you." |
*
* @param {Svc_Ecommerce_Amazon_Tools_Scope_Detail5Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ecommerce_amazon_tools_scope_detail5 = /** @type {((inputs?: Svc_Ecommerce_Amazon_Tools_Scope_Detail5Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ecommerce_Amazon_Tools_Scope_Detail5Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ecommerce_amazon_tools_scope_detail5(inputs)
	if (locale === "bn") return bn_svc_ecommerce_amazon_tools_scope_detail5(inputs)
	if (locale === "de") return de_svc_ecommerce_amazon_tools_scope_detail5(inputs)
	if (locale === "es") return es_svc_ecommerce_amazon_tools_scope_detail5(inputs)
	if (locale === "fr") return fr_svc_ecommerce_amazon_tools_scope_detail5(inputs)
	if (locale === "pt") return pt_svc_ecommerce_amazon_tools_scope_detail5(inputs)
	if (locale === "zh") return zh_svc_ecommerce_amazon_tools_scope_detail5(inputs)
	if (locale === "tr") return tr_svc_ecommerce_amazon_tools_scope_detail5(inputs)
	if (locale === "ru") return ru_svc_ecommerce_amazon_tools_scope_detail5(inputs)
	if (locale === "pl") return pl_svc_ecommerce_amazon_tools_scope_detail5(inputs)
	return en_svc_ecommerce_amazon_tools_scope_detail5(inputs)
});
export { svc_ecommerce_amazon_tools_scope_detail5 as "svc_ecommerce-amazon-tools_SCOPE_detail" }